"use strict";
// _partialFile.js

{
  // 「店舗情報」のスワイパー
  const swiper = new Swiper(".p-shop__swiper", {
    //swiperの名前
    //切り替えのモーション
    speed: 1000, //表示切り替えのスピード
    effect: "slide", //切り替えのmotion (※1)
    allowTouchMove: true, // スワイプで表示の切り替えを有効に

    //最後→最初に戻るループ再生を有効に
    loop: true,
    //自動スライドについて
    autoplay: {
      delay: 3000, //何秒ごとにスライドを動かすか
      stopOnLastSlide: false, //最後のスライドで自動再生を終了させるか
      disableOnInteraction: true, //ユーザーの操作時に止める
      reverseDirection: false, //自動再生を逆向きにする
    },

    //表示について
    centeredSlides: true, //中央寄せにする
    slidesPerView: "1.2",
    spaceBetween: 10,

    //ブレイクポイントによって変える
    breakpoints: {
      768: {
        slidesPerView: 3.5,
      },
    },
  });
  // 「ポリシー」のスワイパー
  const swiper2 = new Swiper(".p-policy__swiper", {
    //swiperの名前
    //切り替えのモーション
    speed: 80000, //表示切り替えのスピード
    effect: "slide", //切り替えのmotion (※1)
    allowTouchMove: false, // スワイプで表示の切り替えを有効に

    //最後→最初に戻るループ再生を有効に
    loop: true,
    //自動スライドについて
    autoplay: {
      delay: 0, //何秒ごとにスライドを動かすか
      stopOnLastSlide: false, //最後のスライドで自動再生を終了させるか
      disableOnInteraction: false, //ユーザーの操作時に止める
      reverseDirection: false, //自動再生を逆向きにする
    },

    //表示について
    centeredSlides: true, //中央寄せにする
    slidesPerView: "auto",
    //ブレイクポイントによって変える
    breakpoints: {
      375: {
        slidesPerView: 0.5,
      },
      768: {
        slidesPerView: 1,
      },
    },
  });

  /* =================================================== 
※1 effectについて
slide：左から次のスライドが流れてくる
fade：次のスライドがふわっと表示
■ fadeの場合は下記を記述
  fadeEffect: {
    crossFade: true
  },
cube：スライドが立方体になり、3D回転を繰り返す
coverflow：写真やアルバムジャケットをめくるようなアニメーション
flip：平面が回転するようなアニメーション
cards：カードを順番にみていくようなアニメーション
creative：カスタマイズしたアニメーションを使うときに使用します

=======================================================
※2 paginationのタイプ
bullets：スライド枚数と同じ数のドットが表示
fraction：分数で表示（例：1 / 3）
progressbar：スライドの進捗に応じてプログレスバーが伸びる
custom：自由にカスタマイズ

=====================================================*/

  // フォーム付のスライダーの場合
  document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById("contact-form");
    const inputs = form.querySelectorAll("input, select, textarea");

    // MutationObserverでGTM属性の動的追加を監視
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-gtm-form-interact-field-id"
        ) {
          const input = mutation.target;
          const gtmFieldId = input.getAttribute("data-gtm-form-interact-field-id");
          if (gtmFieldId && input.name) {
            localStorage.setItem(`gtm_${input.name}`, gtmFieldId);
          }
        }
      });
    });

    // 各input要素を監視
    inputs.forEach((input) => {
      observer.observe(input, {
        attributes: true,
        attributeFilter: ["data-gtm-form-interact-field-id"],
      });
    });

    function saveAllData() {
      inputs.forEach((input) => {
        // フォームデータ保存
        localStorage.setItem(`form_${input.name}`, input.value);

        // GTM属性保存
        const gtmFieldId = input.getAttribute("data-gtm-form-interact-field-id");
        if (gtmFieldId) {
          localStorage.setItem(`gtm_${input.name}`, gtmFieldId);
        }
      });
    }

    function restoreAllData() {
      inputs.forEach((input) => {
        // フォームデータ復元
        const savedValue = localStorage.getItem(`form_${input.name}`);
        if (savedValue) {
          input.value = savedValue;
          if (input.type === "date" && savedValue) {
            input.classList.add("has-value");
          }
        }

        // GTM属性復元
        const savedGTMFieldId = localStorage.getItem(`gtm_${input.name}`);
        if (savedGTMFieldId) {
          input.setAttribute("data-gtm-form-interact-field-id", savedGTMFieldId);
        }
      });
    }

    function clearAllData() {
      inputs.forEach((input) => {
        localStorage.removeItem(`form_${input.name}`);
        localStorage.removeItem(`gtm_${input.name}`);
      });
    }

    // リロード判定
    const isBreakpointReload = sessionStorage.getItem("breakpoint_reload");

    if (isBreakpointReload) {
      sessionStorage.removeItem("breakpoint_reload");
      restoreAllData();
    } else {
      clearAllData();
    }

    // 入力時の自動保存
    inputs.forEach((input) => {
      ["input", "change"].forEach((event) => {
        input.addEventListener(event, function () {
          localStorage.setItem(`form_${this.name}`, this.value);
        });
      });
    });

    // ブレイクポイントリロード処理
    const breakpoint = 767;
    let prevWindowWidth = window.innerWidth;

    window.addEventListener("resize", () => {
      const currentWindowWidth = window.innerWidth;
      if (
        (prevWindowWidth > breakpoint && currentWindowWidth <= breakpoint) ||
        (prevWindowWidth <= breakpoint && currentWindowWidth > breakpoint)
      ) {
        saveAllData(); // 全データ保存
        sessionStorage.setItem("breakpoint_reload", "true");
        location.reload();
      }
      prevWindowWidth = currentWindowWidth;
    });

    // フォーム送信時のクリア
    form.addEventListener("submit", function () {
      clearAllData();
    });
  });
}
